import { Validateable } from "@models/interfaces/validateable";
import { Contact } from "@models/contact";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { Tradable } from "@models/interfaces/tradable";
import { stripFunnyInput } from "@helpers/utils";

export abstract class AssetSendTransaction<A extends Tradable> extends Validateable {
	protected amount_cryptocoin: string = "";
	protected amount_fiat: string = "";
	protected recipient: string = "";
	protected purpose_text: string = "";
	protected try_internal: boolean = true;
	protected wallet_id: string = "";
	protected address_book_wallet_id: string = "";
	protected contact_id: string = "";
	protected auth_code: string = "";
	protected allow_sending: string = "internal";
	protected directTradableWalletOffer: boolean = false;
	protected contact_name: string = "";

	public setContactName(s: string): void {
		this.contact_name = s;
	}

	public setWalletId(id: string): void {
		this.wallet_id = id;
	}

	public setAddressBookWalletId(id: string): void {
		this.address_book_wallet_id = id;
	}

	public getContactName(): string {
		return this.contact_name;
	}

	public isInternalSendType(): boolean {
		return this.getSendType() === "internal";
	}

	public get authCode(): string {
		return this.auth_code;
	}

	public set authCode(code: string) {
		this.auth_code = code;
	}

	public getAuthCode(): string {
		return this.auth_code;
	}

	public setPurposeText(text: string): void {
		this.purpose_text = text;
	}

	public setDirectTradableWalletOffer(b: boolean): void {
		this.directTradableWalletOffer = b;
	}

	public getDirectTradableWalletOffer(): boolean {
		return this.directTradableWalletOffer;
	}

	public setWallet(w: TradableWallet): void {
		let id = "";
		if (w != null) {
			id = w.getId();
		}
		this.wallet_id = id;
	}

	public setContactId(id: string): void {
		this.contact_id = id;
	}

	public getWalletId(): string {
		return this.wallet_id;
	}

	public getAddressBookWalletId(): string {
		return this.address_book_wallet_id;
	}

	public getAmountFiat(): string {
		return this.amount_fiat;
	}

	public setAmountFiat(n: string): void {
		this.amount_fiat = stripFunnyInput(n);
	}

	public setAmountCoin(n: string): void {
		this.amount_cryptocoin = stripFunnyInput(n);
	}

	public getAmountCoin(): string {
		return this.amount_cryptocoin;
	}

	public convertTx(c: Contact): void {
		let field = c.getType("email");
		if (!field) {
			field = c.getFields()[0];
		}
		this.setRecipient(field.getValue());
		this.setContactId(c.getId());
	}

	public getRecipient(): string {
		return this.recipient;
	}

	public setRecipient(id: string): void {
		this.recipient = id;
	}

	public getContactId(): string {
		return this.contact_id;
	}

	public get _purpose_text(): string {
		return this.purpose_text;
	}

	public set _purpose_text(s: string) {
		this.purpose_text = s;
	}

	public get _try_internal(): boolean {
		return this.try_internal;
	}

	public set _try_internal(s: boolean) {
		this.try_internal = s;
	}

	public getTryInternal(): boolean {
		return this.try_internal;
	}

	public setTryInternal(b: boolean): void {
		this.try_internal = b;
	}

	public getSendType(): string {
		if (this.allow_sending === "both") {
			return this.try_internal ? "internal" : "external";
		}
		return this.allow_sending;
	}

	public setSendType(s: string): void {
		this.allow_sending = s;
	}

	public abstract displayRecipient(internal: boolean, isEmail: boolean): string;

	public abstract filter: A;

	public getCurrency(): A {
		return this.filter;
	}

	public setCurrency(c: A): void {
		this.filter = c;
	}
}
